interface Props {
  [key: string]: any
}

function CoxLogo(props: Props): React.ReactElement {
  const { pathClassName, hasOutline, outlineColor, ...rest } = props

  return (
    <svg fill="none" viewBox="0 0 78 32" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M36.7941 22.5042C31.9013 22.5042 27.9349 17.9842 27.9349 12.4082C27.9349 6.83221 31.9013 2.31168 36.7941 2.31168C41.6869 2.31168 45.6533 6.83168 45.6533 12.4077C45.6533 17.9837 41.6874 22.5042 36.7941 22.5042ZM36.7898 0.461011C30.409 0.461011 25.2357 5.81034 25.2357 12.4082C25.2357 19.0061 30.409 24.3549 36.7898 24.3549C43.1706 24.3549 48.344 19.0061 48.344 12.4082C48.344 5.81034 43.1712 0.461011 36.7898 0.461011Z"
        fill="currentColor"
        stroke={outlineColor ?? '#fff'}
        strokeWidth={hasOutline ? '1px' : '0'}
      />
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M21.4363 18.965C18.6576 22.3447 15.0784 22.5042 14.2869 22.5042C9.39412 22.5042 5.42772 17.9837 5.42772 12.4082C5.42772 6.83274 9.39412 2.31221 14.2869 2.31221C15.1936 2.31221 18.704 2.51594 21.4363 5.83807L22.0592 6.59594L22.064 2.43647L21.8693 2.33834C18.2149 0.499408 14.8923 0.444474 14.2832 0.461541C7.90132 0.461541 2.72852 5.80981 2.72852 12.4082C2.72852 19.0066 7.90132 24.3554 14.2832 24.3554C15.216 24.3554 18.4085 24.2055 21.8666 22.5122L22.0645 22.4157L22.0597 18.2055L21.4363 18.965Z"
        fill="currentColor"
        stroke={outlineColor ?? '#fff'}
        strokeWidth={hasOutline ? '1px' : '0'}
      />
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M75.0202 29.2967L61.3339 12.0397L68.6069 3.33941C69.7648 1.93194 70.7376 1.27381 70.7477 1.26687L71.7109 0.622073L66.9925 0.618873L66.9157 0.866873C66.6885 1.60021 66.1584 2.31274 65.8069 2.78421C65.8069 2.78421 60.9888 9.29514 60.1056 10.4866C59.1754 9.30261 54.1498 2.78741 54.1498 2.78741C53.8373 2.37407 53.4101 1.80767 53.1082 0.862073L53.0299 0.61674H47.8688L48.9882 1.27327C49 1.28074 50.2448 2.02367 51.7472 4.11274C53.8085 6.73994 57.5397 11.4994 58.3738 12.5682L50.944 21.4503C49.7872 22.8578 48.8149 23.5175 48.8053 23.5245L47.8453 24.1687L52.5669 24.1698L52.6389 23.9133C52.8645 23.1122 53.8058 21.9287 53.8229 21.9069L59.5829 14.1165C61.5082 16.5714 72.6768 30.8119 72.6768 30.8119C72.8917 31.0791 73.0277 31.3698 73.0704 31.5405H77.2715L76.3829 30.8695C76.3701 30.8615 76.0619 30.669 75.0208 29.2957"
        fill="currentColor"
        stroke={outlineColor ?? '#fff'}
        strokeWidth={hasOutline ? '1px' : '0'}
      />
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M28.5307 30.7447V31.4503H25.5882V27.6503H28.4597V28.3559H26.4624V29.181H28.2266V29.8653H26.4624V30.7442L28.5307 30.7447Z"
        fill="currentColor"
        stroke={outlineColor ?? '#fff'}
        strokeWidth={hasOutline ? '1px' : '0'}
      />
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M32.7611 27.6503V31.4503H32.0389L30.1445 29.1431V31.4503H29.2757V27.6503H30.0032L31.8917 29.9575V27.6503H32.7611Z"
        fill="currentColor"
        stroke={outlineColor ?? '#fff'}
        strokeWidth={hasOutline ? '1px' : '0'}
      />
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M34.7392 28.3671H33.5237V27.6503H36.8346V28.3671H35.6192V31.4503H34.7397L34.7392 28.3671Z"
        fill="currentColor"
        stroke={outlineColor ?? '#fff'}
        strokeWidth={hasOutline ? '1px' : '0'}
      />
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M40.5392 30.7447V31.4503H37.5968V27.6503H40.4682V28.3559H38.4709V29.181H40.2352V29.8653H38.4709V30.7442L40.5392 30.7447Z"
        fill="currentColor"
        stroke={outlineColor ?? '#fff'}
        strokeWidth={hasOutline ? '1px' : '0'}
      />
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M43.7605 31.4503L43.0277 30.3917H42.2186V31.4503H41.3397V27.6503H42.9845C43.9995 27.6503 44.6346 28.1767 44.6346 29.029C44.6346 29.5986 44.3472 30.0167 43.8528 30.2285L44.7056 31.4498H43.761L43.7605 31.4503ZM42.9354 28.3671H42.2186V29.6914H42.9354C43.473 29.6914 43.7445 29.4418 43.7445 29.029C43.7445 28.6109 43.473 28.3671 42.9354 28.3671Z"
        fill="currentColor"
        stroke={outlineColor ?? '#fff'}
        strokeWidth={hasOutline ? '1px' : '0'}
      />
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M48.7237 29.0295C48.7237 29.8759 48.089 30.4029 47.0736 30.4029H46.3077V31.4503H45.4288V27.6503H47.0736C48.0885 27.6503 48.7237 28.1773 48.7237 29.0295ZM47.8336 29.0295C47.8336 28.6114 47.5621 28.3671 47.0245 28.3671H46.3077V29.6861H47.0245C47.5621 29.6861 47.8336 29.4418 47.8336 29.0295Z"
        fill="currentColor"
        stroke={outlineColor ?? '#fff'}
        strokeWidth={hasOutline ? '1px' : '0'}
      />
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M51.8693 31.4503L51.1365 30.3917H50.3275V31.4503H49.4485V27.6503H51.0933C52.1083 27.6503 52.7435 28.1767 52.7435 29.029C52.7435 29.5986 52.456 30.0167 51.9616 30.2285L52.8144 31.4498H51.8699L51.8693 31.4503ZM51.0443 28.3671H50.3275V29.6914H51.0443C51.5819 29.6914 51.8533 29.4418 51.8533 29.029C51.8533 28.6109 51.5819 28.3671 51.0443 28.3671Z"
        fill="currentColor"
        stroke={outlineColor ?? '#fff'}
        strokeWidth={hasOutline ? '1px' : '0'}
      />
      <path
        d="M53.592 27.6503H54.4709V31.4503H53.592V27.6503Z"
        fill="currentColor"
        stroke={outlineColor ?? '#fff'}
        strokeWidth={hasOutline ? '1px' : '0'}
      />
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M55.336 31.0759L55.6347 30.4135C55.9552 30.6471 56.4325 30.8098 56.8885 30.8098C57.4101 30.8098 57.6213 30.6359 57.6213 30.4029C57.6213 29.6919 55.4123 30.1805 55.4123 28.7693C55.4123 28.1234 55.9333 27.5858 57.0133 27.5858C57.4912 27.5858 57.9797 27.6999 58.3328 27.9223L58.0613 28.5895C57.7083 28.389 57.3445 28.2909 57.008 28.2909C56.4864 28.2909 56.2859 28.4861 56.2859 28.725C56.2859 29.4253 58.4949 28.9421 58.4949 30.3373C58.4949 30.9725 57.9685 31.5149 56.8832 31.5149C56.2805 31.5149 55.6725 31.3357 55.3365 31.0754L55.336 31.0759Z"
        fill="currentColor"
        stroke={outlineColor ?? '#fff'}
        strokeWidth={hasOutline ? '1px' : '0'}
      />
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M62.1936 30.7447V31.4503H59.2512V27.6503H62.1227V28.3559H60.1253V29.181H61.8896V29.8653H60.1253V30.7442L62.1936 30.7447Z"
        fill="currentColor"
        stroke={outlineColor ?? '#fff'}
        strokeWidth={hasOutline ? '1px' : '0'}
      />
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M62.9125 31.0759L63.2112 30.4135C63.5317 30.6471 64.0091 30.8098 64.465 30.8098C64.9866 30.8098 65.1978 30.6359 65.1978 30.4029C65.1978 29.6919 62.9888 30.1805 62.9888 28.7693C62.9888 28.1234 63.5098 27.5858 64.5899 27.5858C65.0677 27.5858 65.5563 27.6999 65.9093 27.9223L65.6379 28.5895C65.2848 28.389 64.9211 28.2909 64.5845 28.2909C64.0629 28.2909 63.8624 28.4861 63.8624 28.725C63.8624 29.4253 66.0714 28.9421 66.0714 30.3373C66.0714 30.9725 65.5451 31.5149 64.4597 31.5149C63.8571 31.5149 63.2491 31.3357 62.9131 31.0754L62.9125 31.0759Z"
        fill="currentColor"
        stroke={outlineColor ?? '#fff'}
        strokeWidth={hasOutline ? '1px' : '0'}
      />
    </svg>
  )
}

export default CoxLogo
